import './index.css';
import '@acorn-portal/shared/src/utils/sentry-instrument';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { AnalyticsProvider } from '@acorn/analytics';
import analyticsBuilder from '@acorn-portal/shared/src/analytics/analytics-config';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '@acorn-portal/shared/src/store';
import { AuthProvider } from 'react-oidc-context';
import { getUserManager } from '@acorn-portal/shared/src/utils/get-user-manager';
import App from './App';

if (import.meta.env.VITE_ENV === 'Production') {
	console.log = function () {};
}
const analyticsInstance = analyticsBuilder.forJourney('flag').build();

const userManager = getUserManager();

createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<AuthProvider userManager={userManager}>
			<Provider store={store}>
				<AnalyticsProvider analytics={analyticsInstance}>
					<PersistGate loading={null} persistor={persistor}>
						<App />
					</PersistGate>
				</AnalyticsProvider>
			</Provider>
		</AuthProvider>
	</React.StrictMode>,
);
